 <h3>Basket</h3>

<p *ngIf="items.length == 0">Your basket is empty!</p>

<div class="cart-item" *ngFor="let item of items">
  <span>{{ item.name }} X {{ item.quantity }}</span>
  <span>{{ item.price | currency:'GBP' }}</span>
  <button (click)="removeFromBasket(item.name)" class="button fancy-button"> <mat-icon svgIcon="clear" aria-hidden="false" aria-label="remove item from basket"></mat-icon></button>
</div>


<div *ngIf="items.length != 0">

  <div class="subtotal">
   Subtotal: {{total | currency: 'GBP'}}
  </div>

  <p> Thank you for your purchase! Please fill in the <b>shipping</b> address for your purchase in the form below to begin the checkout process.</p>

<form [formGroup]="checkoutForm" (ngSubmit)="onSubmit(checkoutForm.value)">

<div class="name">
 <mat-form-field appearance="standard">
     <!-- <mat-label>Title</mat-label>
      
      <select matNativeControl id="title" formControlName="title" required>
          <option *ngFor="let title of titles" [value]="title.value">{{title.viewValue}}</option>
      </select>-->

      <mat-select placeholder="title" name="title" formControlName="title" id="title" required>
        <mat-option *ngFor="let title of titles" [value]="title.value">
        {{title.viewValue}}</mat-option>
      </mat-select>
    </mat-form-field>

  <mat-form-field appearance="standard">
    <mat-label>First name</mat-label>
    <input matInput placeholder="First name" id="firstname" formControlName="firstname" type="text" required>
  </mat-form-field>
  <mat-form-field appearance="standard">
    <mat-label>Last name</mat-label>
    <input matInput placeholder="Last name" id="lastname" formControlName="lastname" required>
  </mat-form-field>
</div>

<div class="email">
  <mat-form-field appearance="standard">
    <mat-label>Email</mat-label>
    <input matInput placeholder="email address" id="email" formControlName="email" required>
  </mat-form-field>
</div>

  <div class="address">
    <mat-form-field appearance="standard">
      <mat-label>Address (line 1)</mat-label>
      <input matInput placeholder="Address" id="address1" formControlName="address1" type="text" required>
    </mat-form-field>
  
    <mat-form-field appearance="standard">
      <mat-label>Address (line 2)</mat-label>
      <input matInput placeholder="Address (optional)" id="address2" formControlName="address2" type="text">
    </mat-form-field>
    
    <mat-form-field appearance="standard">
      <mat-label>Town / City / Island</mat-label>
      <input matInput placeholder="City" id="city" formControlName="city" type="text" required>
    </mat-form-field>
  </div>

  <div class="postcode">
    <mat-form-field appearance="standard">
      <mat-label>Postcode</mat-label>
      <input matInput placeholder="Postcode" id="postcode" formControlName="postcode" type="text">
    </mat-form-field>
    
  </div>

  <div class="country">
    <mat-form-field>
      <!--<mat-label>Country</mat-label>-->
      
      <mat-select placeholder="country" id="country" formControlName="country" required>
          <mat-option *ngFor="let country of countries" [value]="country.value">{{country.viewValue}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  

  <button class="button" type="submit">Next</button>

 <!-- <p>
    <a routerLink="/shipping">Shipping Prices</a>
  </p>-->
</form>

<p  *ngIf="checkoutForm.status === 'INVALID'">Please fill in all the form fields marked with an asterisk before continuing.</p>
<p>&nbsp;</p>
</div>
